import axios from "axios";

const local = process.env.REACT_APP_BACKEND_LOCAL_API;
const live = process.env.REACT_APP_BACKEND_LIVE_API;
export const baseUrl = process.env.NODE_ENV === "development" ? local : live;

export function adminHeaders(){
  const token = localStorage.getItem("cejoraTokenDash");
  return { Authorization: `Bearer ${token}` };
}

export async function apiGet(path){ return axios.get(baseUrl + path, { headers: adminHeaders() }); }
export async function apiPost(path, body={}){ return axios.post(baseUrl + path, body, { headers: adminHeaders() }); }
